
export const pageSize = 20;
export const notificationTimeout = 3000;

export const sessionVariables = {
  sv_lguser: "lgusr",
  sv_TicketSearchJson: "ticketSearchJson",
  sv_OrgApiSetting: "orgApiSetting",
  sv_DynamicFormApiSetting: "dynamicFormApiSetting",
}